export default __webpack_public_path__ + "static/media/despacho-aduaneiro.da085880.jpg";